export default new function () {
  this.registerAsset = function (assetId, asset) {
    if (this[assetId]) {
      console.log('AssetId already registered - ' + assetId)
    } else {
      this[assetId] = asset
    }
  }
}()
